<ng-container [ngTemplateOutlet]="mode === 'regenerate' ? regenerate : general"></ng-container>

<db-payment-info [subscription]="chosenPlan"
                 [feature]="'ssh'"
                 [mode]="mode"
                 [currentSubscription]="userSubscription"
                 [isPaypalInvalidCode]="payPalInvalidCoupons.includes(couponCodeInput?.value)"
                 (onClose)="onClose.emit(!!$event)"
                 (onLoading)="loading = $event"
                 (paymentIsPaypal)="handlePaymentIsPaypal($event)"></db-payment-info>

<hr class="mt10">
<ng-container [ngTemplateOutlet]="userSubscription?.type === userSubscriptionType.FREE ? free : paid"></ng-container>

<ng-template #free>
  <div *ngIf="!couponSectionToggled "
       class="db-one-month-free-plans__coupon-link mt20" (click)="couponSectionToggled = true">
    <span>Have a promo code?</span>
  </div>
  <div class="mt20" *ngIf="couponSectionToggled" [ngClass]="{'pb10': coupon?.couponCode}">
    <div class="db-one-month-free-plans__coupon-wrap"
         *ngIf="!coupon || !coupon?.couponCode">
      <div class="ds-input-wrap" [ngClass]="{'with-error': (payPalInvalidCoupons.includes(couponCodeInput?.value) &&
      !!isPaypal)}">
        <input type="text" class="ds-input" [ngClass]="{'error': couponCodeInput?.invalid ||
        (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
               placeholder="Enter promo code" [formControl]="couponCodeInput">
        <i *ngIf="couponCodeInput?.value" class="db-icon db-icon-ds-close delete-coupon" (click)="deleteCoupon(false)"></i>
        <span *ngIf="couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)"
              class="ds-input-error-msg"
              [innerHTML]="((payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal) ?
              'text_invalidPaypalCouponCodeError' : 'text_checkout_coupon_server_error') |
              dbText"></span>
      </div>
      <button class="ds-btn ds-btn-xs" [ngClass]="{'ds-btn-disabled': couponLoading ||
      (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}" (click)="applyCoupon()">
        <span *ngIf="!couponLoading">Apply</span>
        <db-loading-circular-spinner *ngIf="couponLoading" color="dark"></db-loading-circular-spinner>
      </button>
    </div>
    <p *ngIf="coupon?.couponCode && coupon?.couponCode !== '1wf'" class="promo-code">
      <span>{{coupon?.couponCode}}</span>
      <i class="db-icon db-icon-close" (click)="deleteCoupon(!couponCodeInput?.invalid)"></i>
    </p>
  </div>
  <div class="due-today mt20 mb10">
    <p><b>Due today</b><span [innerHTML]="(mode === 'ssh' || !coupon?.freeDaysBeforePayment) ? '' : ' (' + coupon?.freeDaysBeforePayment + ' days free)'"></span></p>
    <b *ngIf="chosenPlan?.price > 0">${{chosenPlan?.price - newPrice}}</b>
  </div>

  <p class="mb25" *ngIf="chosenPlan?.price > 0">Then <span>pay
    ${{chosenPlan?.price}}</span>
    each {{chosenPlan?.type}} beginning
    on {{expirationDate | date: 'MMM d, y'}} until you cancel your subscription.</p>
</ng-template>

<ng-template #paid>
  <div class="due-today mt20 mb10">
    <p><b>{{ 'text_payNow' | dbText }}</b></p>
    <b *ngIf="userSubscription?.plan?.price > 0"> ${{userSubscription?.plan?.price + (userSubscription?.plan?.additionalCDNPrice ? userSubscription?.plan?.additionalCDNPrice : 0) +
    userSubscription?.plan?.additionalDomainPrice}}</b>
  </div>

  <p class="mb25" *ngIf="userSubscription?.plan?.price + userSubscription?.plan?.additionalDomainPrice > 0">Then pay
    ${{ userSubscription?.plan?.planPrice + (userSubscription?.plan?.additionalCDNPrice ? userSubscription?.plan?.additionalCDNPrice : 0) +
    userSubscription?.plan?.additionalDomainPrice }}
    each {{userSubscription?.plan?.periodNumber === 1 ? 'month' : 'year'}} beginning
    on {{expirationDate | date: 'MMM d, y'}} until you cancel your subscription.</p>
</ng-template>

<div class="text-center buttons-wrap">
  <button class="ds-btn-blue ds-btn-xl rectangle mb30" [disabled]="loading" (click)="paymentInfo.checkoutHandler()">
    <span *ngIf="!loading">{{(userSubscription?.type === userSubscriptionType.FREE ? 'proceed' : 'Get Pro Plan') | lowerCaseSpecificWords}}</span>
    <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
  </button>
</div>

<ng-template #regenerate>
  <div class="back mb15">
    <h2>Get more AI generations</h2>
  </div>
  <ng-container *ngIf="userSubscription?.type !== userSubscriptionType.FREE">
    <p class="mb15">
      More generations are only available to paid users.<br/> To get {{userSubscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value}} more AI generations please make a payment.</p>
    <ul class="points mb20">
      <li>
        <i class="db-icon db-icon-ds-checkmark"></i>
        <p [innerHTML]="'You will keep remaining days of 7 days free access.'"></p>
      </li>
      <li>
        <i class="db-icon db-icon-ds-checkmark"></i>
        <p [innerHTML]="'Next payment date will be changed to ' + (expirationDate | date: 'MMM d, y')"></p>
      </li>
    </ul>
  </ng-container>
</ng-template>
<ng-template #general>
  <div class="back mb5">
    <i *ngIf="userSubscription?.type === userSubscriptionType.FREE"
       class="db-icon db-icon-ds-arrow-small"
       (click)="onStepChange.emit('plans')"></i>
    <h2>Get 10Web Pro plans</h2>
  </div>
  <ng-container *ngIf="featureDesc">
    <p class="mb10" [innerHTML]="featureDesc"></p>
  </ng-container>
</ng-template>
